// @flow @jsx h

import { h } from 'preact'
import { FocusOnEnter } from '../lib/FocusOnEnter'
import { Box } from './common/Box'
import { Button } from './common/Button'
import { getTier } from '../../../lib/getTier'
import { result, moreInfo } from '../../config/text'
import styles from './ResultView.css'
import type { Answers } from '../../types'

type Props = {
  currentPosition: number,
  answers: Answers,
  onShareClick: () => void
}

const ResultView = ({ answers, currentPosition, onShareClick }: Props) => {
  const { title, description } = result[getTier(currentPosition)]
  let shareUrl = ''
  if (typeof window !== 'undefined') {
    const metadataUrl = `https://dh.nrk.no/plast-quiz/v1/api/share/${currentPosition}`
    const redirectUrl = (window.location && window.location.href) || ''
    const shareApiUrl =
      'http://share.nrk.no/api/dele/v2/share'
    const shareUrlParam = encodeURIComponent(
      `${shareApiUrl}?r=${encodeURIComponent(
        redirectUrl
      )}&m=${encodeURIComponent(metadataUrl)}`
    )
    shareUrl = `https://www.facebook.com/sharer.php?u=${shareUrlParam}`
  }

  return (
    <Box>
      <FocusOnEnter>
        <h2>{title}</h2>
        <p>{description}</p>
        <div class={styles['result__button-group']}>
          <Button
            onClick={onShareClick}
            target='_blank'
            modifiers={['with-icon', 'slim']}
            href={shareUrl}
          >
            <span aria-hidden>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15 15'>
                <path d='M8.4 4.6c0-.5 0-.8.8-.8h1V2H8.7C7 2 6.2 3.2 6.2 4.6v1H4.7v2h1.5V13h2.2V7.5H10l.2-1.8H8.4v-1z' />
              </svg>
            </span>
            Del resultat
          </Button>
          <Button
            onClick={onShareClick}
            target='_blank'
            modifiers={[
              'with-icon-right',
              'read-more',
              'slim',
              'inverted',
              'border'
            ]}
            href={moreInfo.href}
          >
            {moreInfo.text}
          </Button>
        </div>
      </FocusOnEnter>
    </Box>
  )
}

export { ResultView }



// WEBPACK FOOTER //
// ./src/v1/components/Foreground/ResultView.js